// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1HT7C","topBottomGutter":"Layout_topBottomGutter__3kJSU"};